<template>
	<div class="mt-4 bg-gray-50 px-4 py-6 rounded">
		<p class="text-idrive-dark font-bold text-lg">
			Looking for long term rentals?
		</p>
		<p class="font-thin text-idrive-dark text-base-sm">
			<a
				href="mailto:rentals@idriverentals.com.au"
				target="_blank"
				class="inline-block underline underline-offset-2 duration-300 ease-out hover:decoration-idrive-hover hover:text-idrive-hover"
			>
				Get in touch
			</a>
			with us or call
			<a href="tel:1300004685" class="font-bold">1300 004 685</a>
		</p>
	</div>
</template>
